import {createSlice} from "@reduxjs/toolkit";
import {
    saveComponent,
    addComponent,
    removeComponent,
    fetchScreenComponents, reorderComponents
} from "./componentsThunks";


export const componentsSlice = createSlice({
    name: 'components',
    initialState: {
        screenProperty: null,
        components: [],
        recentAddedComponentId: null,
        loading: true,
        error: null,

    },
    reducers: {
        updateComponent: (state, action) => {
            state.components = state.components.map(component => {
                return component.id === action.payload.id ? action.payload : component;
            });
            /*const index = state.components.findIndex(component => component.id === action.payload.id);
            if (index !== -1) {
                state.components[index] = {...state.components[index], ...action.payload.data};
            }*/
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchScreenComponents.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchScreenComponents.fulfilled, (state, action) => {
                state.loading = false;

                const {components, ...rest} = action.payload;

                state.screenProperty = rest || null;
                state.components = components || [];
                state.recentAddedComponentId = null; // Reset recent added component ID after fetching
            })
            .addCase(fetchScreenComponents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Handle saving a component
            .addCase(saveComponent.pending, (state) => {
                // state.loading = true;
                // state.error = null;
            })
            .addCase(saveComponent.fulfilled, (state, action) => {
                // state.loading = false;
                // Optionally update the component in the state after saving
                /*state.components = state.components.map(component => {
                    return component.id === action.payload.id ? action.payload : component;
                });*/
            })
            .addCase(saveComponent.rejected, (state, action) => {
                // state.loading = false;
                state.error = action.error.message;
            })

            // Handle the saveComponent action
            .addCase(addComponent.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addComponent.fulfilled, (state, action) => {

                state.loading = false;

                if (1 === parseInt(state.screenProperty?.component_limit)){
                    state.components = [action.payload];

                }else {
                    state.components = [...state.components, action.payload];

                }

                state.recentAddedComponentId = action.payload.id;
            })
            .addCase(addComponent.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Handle the removeComponent thunk
            .addCase(removeComponent.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(removeComponent.fulfilled, (state, action) => {
                state.loading = false;
                // Optionally update the component in the state after saving
                state.components = state.components.filter(component => component.id !== action.payload.id);
            })
            .addCase(removeComponent.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(reorderComponents.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(reorderComponents.fulfilled, (state, action) => {
                state.loading = false;
                state.components = action.payload || [];
            })
            .addCase(reorderComponents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })


        ;

    }
});

export const {updateComponent} = componentsSlice.actions;
export default componentsSlice.reducer;